export default __webpack_public_path__ + "static/media/linkedin.d6535f31.svg";